import { ORGANIZATION_PAYMENT_STATUS } from '../constants/api';
export function isTrialActivable(user, proPlan) {
    return !user || !user.plan || !proPlan || user.plan.id !== proPlan.id;
}
export function isTrialExpired(user) {
    const trialExpirationDate = user?.plan?.trialExpirationDate ? new Date(user.plan.trialExpirationDate) : null;
    return !!(user && Object.keys(user).length && trialExpirationDate && trialExpirationDate <= new Date());
}
export function hasUserPaidPlan(user) {
    const expirationDate = user?.plan?.expirationDate ? new Date(user.plan.expirationDate) : null;
    return !!(user && Object.keys(user).length && expirationDate && new Date(expirationDate) >= new Date());
}
export function hasUserProPlan(user, proPlan) {
    return !!(proPlan && Object.keys(proPlan).length && user?.plan && user.plan.id === proPlan?.id);
}
export function isUserPlanValid(user) {
    return user?.plan && user.plan.paymentStatus === ORGANIZATION_PAYMENT_STATUS.VALID;
}
